import _defineProperty from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import moment from 'moment';
import store from 'redux/store';
import ModalHelper from '@components/collection/components/globals/helpers/modal.helper';

var HandlingErrorsHelper = /*#__PURE__*/function () {
  function HandlingErrorsHelper(completeErrorResponse, allTranslations, status) {
    var _this = this;

    var errorCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var url = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var urlsToExcludeFromError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

    _classCallCheck(this, HandlingErrorsHelper);

    this.handleAccountLockStatus = function (error, translations) {
      var lockStatuses = {
        "FROZEN": translations['account.login.error.user.frozen'],
        "INACTIVE": translations['account.login.error.user.inactive'],
        "CLOSED": translations['account.user.activity.details.CUSTOMER_STATUS_CLOSED_OPERATOR']
      },
          currentLockStatus = error.data.accountLockStatus;
      return lockStatuses[currentLockStatus] ? lockStatuses[currentLockStatus] : translations['account.login.error.user.blocked'];
    };

    this.handleSelfExcludedCustomer = function (error, translations) {
      var errorData = error.data;

      if (typeof errorData === 'string') {
        errorData = JSON.parse(errorData);
      }

      if (errorData.isRemoved) {
        return "".concat(translations['account.login.error.self.excluded.removed'], " ").concat(errorData.removedDate);
      } else if (errorData.endDate === "PERMANENT") {
        return translations['account.error.self.excluded.permanent'];
      } else {
        return "".concat(translations['account.error.self.excluded.until'], " ").concat(moment(errorData.endDate).format('DD/MM/YYYY, HH:mm:ss'));
      }
    };

    this.handleTimeoutCustomer = function (error, translations) {
      var errorData = error.data;

      if (typeof errorData === 'string') {
        errorData = JSON.parse(errorData);
      }

      return "".concat(translations['account.error.timeout.until'], " ").concat(moment(errorData.endDate).format('DD/MM/YYYY, HH:mm:ss'));
    };

    this.handleCoolingOffError = function (error, translations) {
      if (error.data === null) {
        return translations['account.login.error.self.excluded.cooling-off.no-details'];
      } else {
        _this.handleSelfExcludedCustomer(error, translations);
      }
    };

    this.handleResponsibleGamingError = function (error, translations) {
      var exceedLimitTranslation = translations['account.user.error.message.exceeded.responsible.limits'];
      var errorMessage = null;
      var type = error.responsibleGamingType;
      var period = error.responsibleGamingPeriod;
      var responsibleGamingTypesMapping = {
        'DEPOSIT': "".concat(exceedLimitTranslation, " ").concat(_this.toLowerCaseHelper(translations['account.user.responsible.gaming.exceeded.on.type.deposit'])),
        'WITHDRAW': "".concat(exceedLimitTranslation, " ").concat(_this.toLowerCaseHelper(translations['account.user.responsible.gaming.exceeded.on.type.withdraw'])),
        'PLACE_BET': "".concat(exceedLimitTranslation, " ").concat(_this.toLowerCaseHelper(translations['account.user.responsible.gaming.exceeded.on.type.placebets'])),
        'LOSS': "".concat(exceedLimitTranslation, " ").concat(_this.toLowerCaseHelper(translations['account.user.responsible.gaming.exceeded.on.type.loss'])),
        'DEPOSIT_COUNT': "".concat(exceedLimitTranslation, " ").concat(_this.toLowerCaseHelper(translations['account.user.responsible.gaming.exceeded.on.type.deposit']))
      };
      errorMessage = responsibleGamingTypesMapping[type];

      if (type === "DEPOSIT_COUNT") {
        var _periodMapping = {
          'DAILY': ". (".concat(translations['customer.max.deposit.count.daily'], ")"),
          'WEEKLY': ". (".concat(translations['customer.max.deposit.count.weekly'], ")"),
          'MONTHLY': ". (".concat(translations['customer.max.deposit.count.monthly'], ")")
        };
        errorMessage += _periodMapping[period];
      }

      var periodMapping = {
        'ONCE': ". (".concat(translations['account.user.responsible.gaming.exceeded.period.once'], ")"),
        'DAILY': ". (".concat(translations['account.user.responsible.gaming.exceeded.period.daily'], ")"),
        'WEEKLY': ". (".concat(translations['account.user.responsible.gaming.exceeded.period.weekly'], ")"),
        'MONTHLY': ". (".concat(translations['account.user.responsible.gaming.exceeded.period.monthly'], ")")
      };
      errorMessage += periodMapping[period];
      return errorMessage;
    };

    this.completeErrorResponse = completeErrorResponse;
    this.translations = allTranslations;
    this.errorCallback = errorCallback;
    this.status = status;
    this.url = url;
    this.urlsToExcludeFromError = urlsToExcludeFromError;
  }

  _createClass(HandlingErrorsHelper, [{
    key: "getCorrectErrorTranslation",
    value: function getCorrectErrorTranslation(errorNumber, translations) {
      var _errorCases;

      var errorCases = (_errorCases = {}, _defineProperty(_errorCases, '-1', translations['activate.account.error.general.error']), _defineProperty(_errorCases, 0, translations['activate.account.success']), _defineProperty(_errorCases, 1, translations['account.login.error.bad.credentials']), _defineProperty(_errorCases, 5, translations['activate.account.error.key.expired']), _defineProperty(_errorCases, 8, translations['errors.entity.not.found']), _defineProperty(_errorCases, 10, translations['account.user.error.email.notsent']), _defineProperty(_errorCases, 11, translations['account.user.self.exclusion.validation.error.invalid.product.forms']), _defineProperty(_errorCases, 12, translations['activate.account.error.invalid.key']), _defineProperty(_errorCases, 13, translations['registration.validation.email-exists']), _defineProperty(_errorCases, 14, translations['account.user.error.duplicate.username']), _defineProperty(_errorCases, 15, translations['registration.error.tac.notaccepted']), _defineProperty(_errorCases, 19, translations['account.user.error.password.not.match']), _defineProperty(_errorCases, 21, translations['not.enough.money']), _defineProperty(_errorCases, 23, translations['account.user.withdraw.error.message.overamount']), _defineProperty(_errorCases, 24, translations['account.user.withdraw.error.message.lessamount']), _defineProperty(_errorCases, 25, translations['account.user.withdraw.error.message.emptybalance']), _defineProperty(_errorCases, 26, translations['account.user.withdraw.error.message.insufficientbalance']), _defineProperty(_errorCases, 33, translations['account.user.withdraw.error.message.pendingbuddytransfer']), _defineProperty(_errorCases, 35, translations['account.user.withdraw.error.message.nomethodsavailable']), _defineProperty(_errorCases, 38, translations['account.user.buddy.transfer.kyc.not.verified']), _defineProperty(_errorCases, 40, translations['account.user.error.message.exceeded.responsible.limits']), _defineProperty(_errorCases, 41, translations['global.server.error.message']), _defineProperty(_errorCases, 44, translations['errors.casino.game.play.realMoneyNotSupported']), _defineProperty(_errorCases, 45, translations['errors.casino.game.play.demoNotSupported']), _defineProperty(_errorCases, 47, translations['account.user.buddy.transfer.send.yourself.email.error']), _defineProperty(_errorCases, 48, translations['activate.account.key.already.used']), _defineProperty(_errorCases, 49, translations['account.login.error.ip.forbidden']), _defineProperty(_errorCases, 50, translations['gaming.error.game.excluded']), _defineProperty(_errorCases, 51, translations['account.user.account.transfer.not.allowed']), _defineProperty(_errorCases, 52, translations['account.user.buddy.transfer.not.allowed']), _defineProperty(_errorCases, 53, translations['account.user.account.transfer.send.yourself.email.error']), _defineProperty(_errorCases, 54, translations['registration.error.too.many.registrations.same.ip']), _defineProperty(_errorCases, 56, translations['registration.error.duplicate.data']), _defineProperty(_errorCases, 57, translations['registration.error.bad-customer-data']), _defineProperty(_errorCases, 59, translations['account.login.error.gamstop.error']), _defineProperty(_errorCases, 69, translations['account.login.error.user.frozen']), _defineProperty(_errorCases, 72, translations['file.format.not.allowed']), _defineProperty(_errorCases, 75, translations['account.login.pipars.api.call.failed']), _defineProperty(_errorCases, 76, translations['account.login.pipars.customer.self.excluded']), _defineProperty(_errorCases, 77, translations['account.login.pipars.customer.invalid.identity']), _defineProperty(_errorCases, 80, translations['sms.verification.problem.sending.sms']), _defineProperty(_errorCases, 81, translations['sms.verification.pause.window.error']), _defineProperty(_errorCases, 82, translations['sms.verification.invalid.verification.code']), _defineProperty(_errorCases, 83, translations['sms.verification.disabled.exception']), _defineProperty(_errorCases, 84, translations['sms.verification.max.codes.limit.reached']), _defineProperty(_errorCases, 91, translations['account.user.kyc.verification.required']), _defineProperty(_errorCases, 95, translations['sms.verification.sms.providers.disabled']), _errorCases);
      return errorCases[errorNumber];
    }
  }, {
    key: "toLowerCaseHelper",
    value: function toLowerCaseHelper(value) {
      return value.toLowerCase();
    }
  }, {
    key: "handleForgotPassModalSwitch",
    value: function handleForgotPassModalSwitch() {
      if (store.getState().generalConfig.data.forgotPasswordSmsVerificationEnabled === "true") {
        window['router'].push(window['router'].location.pathname + '?modal=forgot-password-sms');
      } else {
        window['router'].push(window['router'].location.pathname + '?modal=forgot-password');
      }
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage() {
      var onlyReturn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var errorCode = this.completeErrorResponse.errorCode;
      var errorMessage = null;

      if (errorCode === 2) {
        errorMessage = this.handleAccountLockStatus(this.completeErrorResponse, this.translations);
      } else if (errorCode === 12) {
        errorMessage = this.translations['activate.account.error.invalid.key'];
      } else if (errorCode === 39) {
        errorMessage = this.handleSelfExcludedCustomer(this.completeErrorResponse, this.translations);
      } else if (errorCode === 40) {
        errorMessage = this.handleResponsibleGamingError(this.completeErrorResponse, this.translations);
      } else if (errorCode === 58) {
        this.handleForgotPassModalSwitch();
      } else if (errorCode === 66) {
        errorMessage = this.handleCoolingOffError(this.completeErrorResponse, this.translations);
      } else if (errorCode === 93) {
        errorMessage = this.handleTimeoutCustomer(this.completeErrorResponse, this.translations);
      } else {
        if (this.getCorrectErrorTranslation(errorCode, this.translations)) {
          errorMessage = this.getCorrectErrorTranslation(errorCode, this.translations);
        } else {
          if (this.completeErrorResponse.errorCode === 3 && this.completeErrorResponse.errorMessage === 'Unauthorized') {
            var event = new CustomEvent('LOGOUT', {
              'detail': {
                action: 'LOGOUT',
                data: {
                  callback: function callback() {
                    ModalHelper.router.push(ModalHelper.router.location.pathname + '?modal=login');
                  }
                }
              }
            });
            document.body.dispatchEvent(event);
          } else {
            errorMessage = this.getCorrectErrorTranslation(41, this.translations);
          }
        }
      }

      if (onlyReturn) {
        return errorMessage;
      }

      if (this.errorCallback && this.status === 500 && Object.keys(this.translations).length && errorMessage) {
        if (this.urlsToExcludeFromError && this.url) {
          var trimmedUrl = '';

          if (this.url.includes('api/v1/notifications/customerfacing')) {
            trimmedUrl = 'notifications';
          } else {
            trimmedUrl = this.url.replace('api/v1/customerfacing/', '').replace('api/v2/customerfacing/', '').split('?')[0];
          }

          if (!this.urlsToExcludeFromError.includes(trimmedUrl)) {
            this.errorCallback(errorMessage, this.status);
          }
        } else {
          this.errorCallback(errorMessage, this.status);
        }
      }
    }
  }]);

  return HandlingErrorsHelper;
}();

export default HandlingErrorsHelper;